import {Fragment, useEffect, useState} from 'react'
import {createTheme, ThemeProvider} from '@mui/material/styles'
import {useDispatch, useSelector} from 'react-redux'
import type {AppDispatch, RootState} from 'redux/store'
import {datadogRum} from '@datadog/browser-rum'
import _ from 'lodash'
import Footer from './features/Footer'
import Header from './shared/Header'
import MainRoute from 'Routes'
import Notifications from 'features/Notifications'
import GoToTop from 'shared/GotoTop'
import AccessPopup from 'shared/AccessPopup'
import {ENDPOINT} from 'config/path'
import {useLocation, useNavigate} from 'react-router-dom'
import LoginPopup from 'features/HomePage/components/LoginPopup'
import {fetchMenuItem} from 'features/Login/login.slice'
// Commented Pendo related Information
// declare global {
//     interface Window {
//         // Add the 'pendo' property to the Window interface
//         pendo: any
//     }
// }

const App = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const [popupYN, setpopupYN] = useState<boolean>(false)
    const login = useSelector((state: RootState) => state.login.loginDetails)
    const isLoggedIn = useSelector((state: RootState) => state.login.isLoggedIn)
    const securityParams = useSelector((state: RootState) => state.login.loginDetails?.securityParams)
    const pageLevelAccessInfo = useSelector((state: RootState) => state.common.userAccessLevels.pageLevelAccess)
    const showLoginPopup = useSelector((state: RootState) => state.login.showLoginPopup)
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0, // 0px to 767px - mobile (xs)
                sm: 768, // 768px to 1023px - tablet (sm)
                md: 1024, // 1024px and above - desktop (md, lg, xl)
                lg: 1440, // max-width of container
                xl: 1920
            }
        }
    })

    /**
     * This hook is used to perform a validaiton check for the access level in redux and the page
     * that user is trying to open. If the user doesn't have access then a popup is shown and automatically
     * being redirected to the dashboard. This hook will be triggerred whenever the path or accesslevel
     * changes.
     */
    useEffect(() => {
        if (!pageLevelAccessInfo) return
        if (_.size(pageLevelAccessInfo) === 0) return

        const {Marketplace: MarketPlaceAccess} = pageLevelAccessInfo
        const currentPath = location.pathname

        // TODO: Need to create a custom function which would handle the routes and access levels
        // TODO: dynamically for all the pages
        if (_.includes(_.toLower(currentPath), _.toLower(ENDPOINT.marketPlace))) {
            if (MarketPlaceAccess) setpopupYN(false)
            else {
                navigate(ENDPOINT.dashboard, {replace: true})
                setpopupYN(true)
            }
        }
    }, [location.pathname, navigate, pageLevelAccessInfo])

    useEffect(() => {
        if (isLoggedIn) {
            const firstname = _.get(securityParams, 'firstName', 'CPSGUEST')
            const secondname = _.get(securityParams, 'lastName', 'CPSGUEST')
            const fullName = `${firstname} ${secondname}` || 'CPSGUEST'
            const user = {
                id: _.get(securityParams, 'userID', 'CPSGUEST'),
                name: fullName,
                email: _.get(securityParams, 'email', 'CPSGUEST')
            }
            datadogRum.setUser(user)
            void dispatch(fetchMenuItem({loginDetails: login}))
        }
    }, [securityParams])
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                {showLoginPopup && !isLoggedIn && <LoginPopup />}
                <Header />
                <MainRoute />
                <AccessPopup isOpen={popupYN} pageName='Marketplace' />
                <GoToTop />
                <Footer />
                {isLoggedIn && <Notifications />}
            </ThemeProvider>
        </Fragment>
    )
}
export default App
